import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate, useParams } from 'react-router-dom';
import { EntityList, PageHead } from '../../components/EntityList';
import { useLabels } from '../../hooks/useLabels';
import { useEditorReturn } from '../../hooks/useEditorReturn';
import AssetSaleEditor from './AssetSaleEditor';

function AddAssetSale() {
	const { t } = useLabels();
	const { id } = useParams();
	const navigate = useNavigate();
	const { returnTo, onReturn, returnLabel } = useEditorReturn();
	const backTo = `/AdminScreen/assets/asset/${id}/sales`;
	const handleCancel = () => navigate(backTo);
	const handleSaved = (savedAssetSaleId) => {
		if (returnTo) {
			const target = new URL(returnTo, window.location.origin);
			target.searchParams.set('assetSaleId', savedAssetSaleId);
			navigate(`${target.pathname}${target.search}`);
			return;
		}
		navigate(backTo);
	};

	return (
		<EntityList>
			<Helmet>
				<title>{t('title.assetSale')}</title>
			</Helmet>
			<PageHead
				breadcrumb={[
					{ label: 'Inicio', to: '/AdminScreen' },
					{ label: t('entity.asset.plural'), to: '/AdminScreen/assets' },
					{ label: t('entity.asset'), to: `/AdminScreen/assets/asset/${id}` },
					{ label: t('title.assetSale') },
				]}
				title={t('title.assetSale')}
				subtitle='Completá los datos para registrar la venta.'
			/>
			<AssetSaleEditor
				mode='create'
				preloadAssetId={id}
				onCancel={handleCancel}
				onSaved={handleSaved}
				onReturn={onReturn}
				returnLabel={returnLabel}
			/>
		</EntityList>
	);
}

export default AddAssetSale;
